export default __webpack_public_path__ + "static/media/peperoneTtsIt_It60.b5b04342.mp3";